import React from "react";

import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom-v5-compat";

import welcome from "../assets/images/welcome_journey/Welcome_red.png";
import { TwoColumnPage, InfoPage, ContentBlock, Testimonial } from "./Atoms";
import { Form, TextField, CheckBoxField, Button } from "./Form";
import { useJourney, userFieldsFrom } from "./sign_up_journeys";

const ReadyToSeeMoreInfo = () => {
  const { journey } = useJourney();
  const { t } = useTranslation("welcome");
  return (
    <InfoPage title={t("readyToSeeMore.title", { name: journey.firstName })}>
      <ContentBlock
        content={[
          t("readyToSeeMore.content.0", { venueName: journey.venueName }),
        ]}
      />
      <ContentBlock content={[t("readyToSeeMore.content.1")]} />
      <div>
        <img src={welcome} />
      </div>
    </InfoPage>
  );
};

const ReadyToSeeMoreForm = ({}) => {
  const { t } = useTranslation("welcome");
  const {
    journey,
    formProps: { handleSubmit, ...formProps },
  } = useJourney();

  // This is pretty ugly to add here.
  // But its a quick and dirty way to get the csrf token submitted
  // So rails and devise do not reject the form
  const csrf = document
    .querySelector("meta[name='csrf-token']")
    .getAttribute("content");
  return (
    <Form method="post" action="/users">
      <h1 className="text-center">{t("formContent.readyToSeeMoreTitle")}</h1>
      {Object.entries(userFieldsFrom(journey)).map(([name, value]) => (
        <input type="hidden" name={`user[${name}]`} defaultValue={value} />
      ))}

      <input type="hidden" name="authenticity_token" defaultValue={csrf} />
      <CheckBoxField
        formProps={formProps}
        name="users[terms]"
        label={t("formContent.terms")}
        checkBoxLabel={
          <Trans
            i18nKey="formContent.acceptTerms"
            components={{
              TermsLink: (
                <a
                  className="text-accent-700"
                  target="_blank"
                  href="http://www.posbosshq.com/terms-of-service"
                />
              ),
            }}
          />
        }
        required
      />
      <TextField
        formProps={formProps}
        required
        minLength={8}
        type="password"
        name="user[password]"
        label={t("formContent.password")}
      />

      <Testimonial
        quote={<Trans t={t} i18nKey="testimonial.daniel.quote" />}
        name={t("testimonial.daniel.name")}
        venue={t("testimonial.daniel.venue")}
      />
      <div className="text-center">
        <Button primary>{t("readyToSeeMore.nextButton")}</Button>
      </div>
    </Form>
  );
};
const ReadyToSeeMore = ({ progress }) => {
  return (
    <TwoColumnPage
      progress={progress}
      left={<ReadyToSeeMoreInfo />}
      right={<ReadyToSeeMoreForm />}
    />
  );
};

export default ReadyToSeeMore;
